export default function(options = {}){

    /**
     * Options for this method
     */
    const opts = $.extend({
        countryCode: 'gb',
        onBeforeSearch: null,
        onResponse: null,
        onSelect: null,
        selector: null,
    }, options);

    /**
     * The element to instantiate
     * @type {jQuery}
     */
    const element = $(opts.selector);

    /**
     * Determine whether the set country uses Google Places location autocomplete
     * @returns {boolean}
     */
    const countryUsesGooglePlacesAutocomplete = () => {
        return [
            'ie',
        ].includes((opts.countryCode || '').toLowerCase());
    };

    /**
     * Bind Google Places autocomplete for the location input
     */
    const bindGooglePlacesAutocomplete = () => {
        let autocompleteAuto;

        /**
         * Normalise the response from Google into something more universally usable
         */
        const normaliseAddressAndSendToCallback = () => {
            const place = autocompleteAuto.getPlace() || {};

            const normalised = {
                id: place.place_id,
                lat: place.geometry && place.geometry.location && place.geometry.location.lat,
                lng: place.geometry && place.geometry.location && place.geometry.location.lng,
                name: place.name,
                type: 'goog'
            };

            opts.onSelect && opts.onSelect(normalised);
        }

        /**
         * Actually initialise the Google library that does autocompletion
         * @author Original author unknown
         */
        const initAutocompleteAuto = () => {
            const inputs = document.querySelectorAll(opts.selector);

            Array.prototype.forEach.call(inputs, input => {
                const options = {
                    componentRestrictions: {
                        country: opts.countryCode.toLowerCase()
                    }
                };

                autocompleteAuto = new google.maps.places.Autocomplete(input, options);
                autocompleteAuto.addListener('place_changed', normaliseAddressAndSendToCallback);

                input.classList.add('is-autocomplete-ready');

                $(input).data({locationInputHandler: autocompleteAuto});
            });
        }

        initAutocompleteAuto();
    };

    /**
     * Bind streamcomplete
     */
    const bindStreamComplete = () => {
        const locationInputHandler = streamComplete(opts.selector, 'location', 'POST', item => {
            opts.onSelect && opts.onSelect(item);
        });

        locationInputHandler.s.onbeforesearch = payload => {
            payload.coid = window.Bark.ENV.ccid;

            if (opts.onBeforeSearch && opts.onBeforeSearch(payload) === false) {
                return false;
            }
        };

        locationInputHandler.s.onresponse = ({data, status}) => {
            if (opts.onResponse && opts.onResponse(status, data) === false) {
                return;
            }

            if (status && data?.length === 1) {
                opts.onSelect && opts.onSelect(data[0]);
            }
        };

        element.data({locationInputHandler});
    };

    /**
     * Bind the selector
     */
    const bind = () => {
        let locationInputType;
        if (countryUsesGooglePlacesAutocomplete()) {
            bindGooglePlacesAutocomplete();
            locationInputType = 'google';
        } else {
            bindStreamComplete();
            locationInputType = 'streamcomplete';
        }

        element.data({locationInputType});
    };

    bind();
};
